import type { Transition, TargetAndTransition } from "framer-motion";

/* ---------- Content entrance ---------- */
export const contentContainerInitial: TargetAndTransition = {
  opacity: 0,
  y: 20,
};
export const contentContainerInView: TargetAndTransition = {
  opacity: 1,
  y: 0,
};
export const contentContainerTransition: Transition = {
  duration: 0.5,
};

export const heroHeadingTransition: Transition = {
  duration: 0.7,
};

export const heroBodyTransition: Transition = {
  duration: 0.5,
  delay: 0.1,
};

export const buttonHover: TargetAndTransition = { scale: 1.04 };
export const buttonTap: TargetAndTransition = { scale: 0.97 };

/* ---------- Hub visual entrance ---------- */
export const hubInitial: TargetAndTransition = { opacity: 0, scale: 0.92 };
export const hubInView: TargetAndTransition = { opacity: 1, scale: 1 };
export const hubTransition: Transition = { duration: 0.8, delay: 0.15 };

/* ---------- Slow ring rotation (decorative) ---------- */
export const ringRotate: TargetAndTransition = { rotate: [0, 360] };
export const ringRotateTransition: Transition = {
  duration: 60,
  repeat: Infinity,
  ease: "linear",
};

/* ---------- Satellite fade-in (staggered) ---------- */
export const satelliteInitial: TargetAndTransition = { opacity: 0, scale: 0.6 };
export const satelliteInView: TargetAndTransition = { opacity: 1, scale: 1 };
export const satelliteTransition = (i: number): Transition => ({
  duration: 0.5,
  delay: 0.3 + i * 0.08,
});

/* ---------- Value card entrance ---------- */
export const cardInitial: TargetAndTransition = { opacity: 0, y: 24 };
export const cardInView: TargetAndTransition = { opacity: 1, y: 0 };
export const cardTransition = (i: number): Transition => ({
  duration: 0.5,
  delay: 0.2 + i * 0.12,
});
